// External Import
import React from 'react';
import {
  InputLabel,
  Input,
  FormControl,
  FormControlLabel,
  Checkbox,
  withStyles,
  Select,
  MenuItem,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import NumberFormat from 'react-number-format';
import { useSetState } from '~/app/Utility/customHooks';
// Internal Import
import AccessControl from '#/Auth/AccessControl.jsx';
import infoIcon from '~/images/icons/icons8-info.svg';
import SimpleDialog from '#/Common/SimpleDialog.jsx';
// Styling imports
import { styles } from '#/NewAccount/SingleOffice/css/genBillTwo.js';

const GenBillTwo = props => {
  const { classes } = props;
  const [state, setState] = useSetState({
    isInfoStateTaxRateOpen: false,
  });

  const handleInfoModal = () => {
    setState({ isInfoStateTaxRateOpen: !state.isInfoStateTaxRateOpen });
  };

  const handledefaultDisbursementValue = defaultDisbursementValue => {
    if (defaultDisbursementValue === '1') {
      return 'Direct Deposit';
    }
    if (defaultDisbursementValue === '2') {
      return 'Card';
    }
    if (defaultDisbursementValue === '3') {
      return 'Check';
    }
    return 'None';
  };

  const priorYearBalanceValue = props.billOptsAndRate.priorYearBalance ? 'true' : 'false';
  const priorYearOverPaymentValue = props.billOptsAndRate.priorYearOverPayment ? 'true' : 'false';
  const noBillStandardDeductionValue = props.billOptsAndRate.noBillStandardDeduction
    ? 'true'
    : 'false';
  const defaultDisbursementValue = props.billOptsAndRate.bankDisbursementOption;
  const preventTransmitValue = props.billOptsAndRate.preventTransmit ? 'true' : 'false';
  const validatePriorYearBalanceValue = props.billOptsAndRate.validatePriorYearBalance
    ? 'true'
    : 'false';
  const disableInvoicingValue = props.billOptsAndRate.disableInvoicing ? 'true' : 'false';
  const billOnlyEFValue = props.billOptsAndRate.billOnlyEF ? 'true' : 'false';
  const taxBillingsValue = props.billOptsAndRate.taxBillings ? 'true' : 'false';
  const noPriorYearPrepFeeValue = props.billOptsAndRate.noPriorYearPrepFee ? 'true' : 'false';
  const disableInvoiceWarningErrorsValue = props.billOptsAndRate.disableInvoiceWarningErrors
    ? 'true'
    : 'false';
  const billQuantityOnePerFormValue = props.billOptsAndRate.billQuantityOnePerForm
    ? 'true'
    : 'false';

  return (
    <AccessControl requiredAction="write" accessLevel="add/edit_billing" disableOnFalse={true}>
      <div style={{ float: 'left' }}>
        <div style={{ marginLeft: '3vw' }}>
          <FormControl required>
            <InputLabel
              classes={{ root: classes.labelWidthStyle }}
              required={false}
              htmlFor="txtStateSalesTaxGenBillTwo"
              shrink
            >
              State Sales Tax Rate
              <img
                id="infoStateSalesTax"
                onClick={handleInfoModal}
                className="state-sales-tax-info-btn"
                src={infoIcon}
                style={{ marginLeft: '.4rem' }}
              />
            </InputLabel>
            <NumberFormat
              id="txtStateSalesTaxGenBillTwo"
              value={props.billOptsAndRate.stateSalesTax || ''}
              onChange={e =>
                props.handleChange(
                  'billOptsAndRate',
                  'stateSalesTax',
                  e.target.value.replace(/[$,%]/g, ''),
                )
              }
              classes={{ root: classes.fieldStyle }}
              disableUnderline
              customInput={Input}
              fixedDecimalScale={true}
              decimalScale={3}
              suffix="%"
              isAllowed={values => {
                const { floatValue } = values;
                return (
                  (floatValue >= 0.0001 && floatValue <= 99.999) || values.formattedValue === ''
                );
              }}
            />
          </FormControl>
        </div>
        <div style={{ marginLeft: '3vw' }}>
          <FormControl required>
            <InputLabel
              classes={{ root: classes.labelWidthStyle }}
              required={false}
              htmlFor="txtSelfPreparedRateGenBillTwo"
              shrink
            >
              Self Prepared Flat Rate
            </InputLabel>
            <NumberFormat
              id="txtSelfPreparedRateGenBillTwo"
              value={props.billOptsAndRate.selfPreparedRate || ''}
              onChange={e =>
                props.handleChange(
                  'billOptsAndRate',
                  'selfPreparedRate',
                  e.target.value.replace(/[$,%]/g, ''),
                )
              }
              classes={{ root: classes.fieldStyle }}
              disableUnderline
              customInput={Input}
              fixedDecimalScale={true}
              decimalScale={2}
              prefix="$"
              thousandSeparator={true}
            />
          </FormControl>
        </div>
        {props.season > 2024 && (
          <div style={{ marginLeft: '3vw' }}>
            <FormControl>
              <InputLabel
                required={false}
                classes={{ root: classes.labelWidthStyle }}
                id="txtBankDisbursementGenBillTwo"
                shrink
              >
                Default Bank App Disbursement Options
              </InputLabel>
              <Select
                value={handledefaultDisbursementValue(defaultDisbursementValue)}
                classes={{ root: classes.fieldStyleSelect }}
                id="txtBankDisbursementGenBillTwo"
                onChange={e =>
                  props.handleChange('billOptsAndRate', 'bankDisbursementOption', e.target.value)
                }
                input={
                  <Input
                    name="Disbursement_type_id"
                    id="Disbursementtype-selected"
                    disableUnderline
                    classes={{ root: classes.fieldStyle }}
                  />
                }
              >
                {['None', 'Direct Deposit', 'Card', 'Check'].map((item, index) => {
                  return (
                    <MenuItem key={'disbursementTypeDropDownMenu' + index} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        )}
        <div>
          <FormControl>
            <div style={{ marginLeft: '3vw' }}>
              <FormControlLabel
                label="No prior year balance on invoice"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkPriorYearBalanceGenBillTwo"
                    checked={
                      props.billOptsAndRate.priorYearBalance === null
                        ? false
                        : props.billOptsAndRate.priorYearBalance
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'priorYearBalance', e.target.checked)
                    }
                    color="primary"
                    value={priorYearBalanceValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
        {props.season >= 2023 && (
          <div>
            <FormControl>
              <div style={{ marginLeft: '3vw' }}>
                <FormControlLabel
                  label="No prior year overpayment on invoice"
                  classes={{ root: classes.labelWidthStyleCheckbox }}
                  control={
                    <Checkbox
                      id="chkPriorYearOverPaymentGenBillTwo"
                      checked={
                        props.billOptsAndRate.priorYearOverPayment === null
                          ? false
                          : props.billOptsAndRate.priorYearOverPayment
                      }
                      onChange={e =>
                        props.handleChange(
                          'billOptsAndRate',
                          'priorYearOverPayment',
                          e.target.checked,
                        )
                      }
                      color="primary"
                      value={priorYearOverPaymentValue}
                      icon={
                        <CheckBoxOutlineBlankIcon
                          classes={{ root: classes.checkBoxBlank }}
                          color="secondary"
                        />
                      }
                      checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                    />
                  }
                />
              </div>
            </FormControl>
          </div>
        )}
        <div>
          <FormControl>
            <div style={{ marginLeft: '3vw' }}>
              <FormControlLabel
                label="Don't bill for Sch A when using STD deduction"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkNoBillStandardDeductionGenBillTwo"
                    checked={
                      props.billOptsAndRate.noBillStandardDeduction === null
                        ? false
                        : props.billOptsAndRate.noBillStandardDeduction
                    }
                    onChange={e =>
                      props.handleChange(
                        'billOptsAndRate',
                        'noBillStandardDeduction',
                        e.target.checked,
                      )
                    }
                    color="primary"
                    value={noBillStandardDeductionValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
        {props.season < 2025 && (
          <div>
            <FormControl>
              <div style={{ marginLeft: '3vw' }}>
                <FormControlLabel
                  label="Turn off default Bank App disbursement options"
                  classes={{ root: classes.labelWidthStyleCheckbox }}
                  control={
                    <Checkbox
                      id="chkBankDisbursementOptionGenBillTwo"
                      checked={
                        props.billOptsAndRate.bankDisbursementOption === null
                          ? false
                          : props.billOptsAndRate.bankDisbursementOption
                      }
                      onChange={e =>
                        props.handleChange(
                          'billOptsAndRate',
                          'bankDisbursementOption',
                          e.target.checked,
                        )
                      }
                      color="primary"
                      value={defaultDisbursementValue}
                      icon={
                        <CheckBoxOutlineBlankIcon
                          classes={{ root: classes.checkBoxBlank }}
                          color="secondary"
                        />
                      }
                      checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                    />
                  }
                />
              </div>
            </FormControl>
          </div>
        )}
        <div>
          <FormControl>
            <div style={{ marginLeft: '3vw' }}>
              <FormControlLabel
                label="Prevent transmit on returns with a balance due fees"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkPreventTransmitGenBillTwo"
                    checked={
                      props.billOptsAndRate.preventTransmit === null
                        ? false
                        : props.billOptsAndRate.preventTransmit
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'preventTransmit', e.target.checked)
                    }
                    color="primary"
                    value={preventTransmitValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>

        <div>
          <FormControl>
            <div style={{ marginLeft: '3vw' }}>
              <FormControlLabel
                label="Validate the prior year balance"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkValidatePriorYearBalance"
                    checked={
                      props.billOptsAndRate.validatePriorYearBalance === null
                        ? false
                        : props.billOptsAndRate.validatePriorYearBalance
                    }
                    onChange={e =>
                      props.handleChange(
                        'billOptsAndRate',
                        'validatePriorYearBalance',
                        e.target.checked,
                      )
                    }
                    color="primary"
                    value={validatePriorYearBalanceValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
      </div>

      <div style={{ float: 'none', marginLeft: '35vw' }}>
        <div>
          <FormControl required>
            <InputLabel
              classes={{ root: classes.labelWidthStyle }}
              required={false}
              htmlFor="txtTaxDiscountGenBillTwo"
              shrink
            >
              Tax Preparation Discount
            </InputLabel>
            <NumberFormat
              id="txtTaxDiscountGenBillTwo"
              value={props.billOptsAndRate.taxDiscount || ''}
              onChange={e =>
                props.handleChange(
                  'billOptsAndRate',
                  'taxDiscount',
                  e.target.value.replace(/[$,%]/g, ''),
                )
              }
              classes={{ root: classes.fieldStyle }}
              disableUnderline
              customInput={Input}
              fixedDecimalScale={true}
              decimalScale={2}
              suffix="%"
              thousandSeparator={true}
            />
          </FormControl>
        </div>
        <div>
          <FormControl required>
            <InputLabel
              classes={{ root: classes.labelWidthStyle }}
              required={false}
              htmlFor="txtHourlyRateGenBillTwo"
              shrink
            >
              Default Hourly Rate
            </InputLabel>
            <NumberFormat
              id="txtHourlyRateGenBillTwo"
              value={props.billOptsAndRate.hourlyRate || ''}
              onChange={e =>
                props.handleChange(
                  'billOptsAndRate',
                  'hourlyRate',
                  e.target.value.replace(/[$,%]/g, ''),
                )
              }
              classes={{ root: classes.fieldStyle }}
              disableUnderline
              customInput={Input}
              fixedDecimalScale={true}
              decimalScale={2}
              prefix="$"
              thousandSeparator={true}
            />
          </FormControl>
        </div>
        <div>
          <FormControl>
            <div>
              <FormControlLabel
                label="Disable invoicing"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkDisableInvoicingGenBillTwo"
                    checked={
                      props.billOptsAndRate.disableInvoicing === null
                        ? false
                        : props.billOptsAndRate.disableInvoicing
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'disableInvoicing', e.target.checked)
                    }
                    color="primary"
                    value={disableInvoicingValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
        <div>
          <FormControl>
            <div>
              <FormControlLabel
                label="Bill for electronically filed forms only"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkBillOnlyEFGenBillTwo"
                    checked={
                      props.billOptsAndRate.billOnlyEF === null
                        ? false
                        : props.billOptsAndRate.billOnlyEF
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'billOnlyEF', e.target.checked)
                    }
                    color="primary"
                    value={billOnlyEFValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
        <div>
          <FormControl>
            <div>
              <FormControlLabel
                label="Collect tax on billings?"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkTaxBillingsGenBillTwo"
                    checked={
                      props.billOptsAndRate.taxBillings === null
                        ? false
                        : props.billOptsAndRate.taxBillings
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'taxBillings', e.target.checked)
                    }
                    color="primary"
                    value={taxBillingsValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>
        <div>
          <FormControl>
            <div>
              <FormControlLabel
                label="No prior year preparation fee on invoice"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkNoPriorYearPrepFeeGenBillTwo"
                    checked={
                      props.billOptsAndRate.noPriorYearPrepFee === null
                        ? false
                        : props.billOptsAndRate.noPriorYearPrepFee
                    }
                    onChange={e =>
                      props.handleChange('billOptsAndRate', 'noPriorYearPrepFee', e.target.checked)
                    }
                    color="primary"
                    value={noPriorYearPrepFeeValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>

        <div>
          <FormControl>
            <div>
              <FormControlLabel
                label="Disable invoice warning errors"
                classes={{ root: classes.labelWidthStyleCheckbox }}
                control={
                  <Checkbox
                    id="chkDisableInvoiceWarningErrorsGenBillTwo"
                    checked={
                      props.billOptsAndRate.disableInvoiceWarningErrors === null
                        ? false
                        : props.billOptsAndRate.disableInvoiceWarningErrors
                    }
                    onChange={e =>
                      props.handleChange(
                        'billOptsAndRate',
                        'disableInvoiceWarningErrors',
                        e.target.checked,
                      )
                    }
                    color="primary"
                    value={disableInvoiceWarningErrorsValue}
                    icon={
                      <CheckBoxOutlineBlankIcon
                        classes={{ root: classes.checkBoxBlank }}
                        color="secondary"
                      />
                    }
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                  />
                }
              />
            </div>
          </FormControl>
        </div>

        {props.season >= 2026 && (
          <div>
            <FormControl>
              <div>
                <FormControlLabel
                  label="Bill quantity one per form only"
                  classes={{ root: classes.labelWidthStyleCheckbox }}
                  control={
                    <Checkbox
                      id="chkBillQuantityOnePerFormGenBillTwo"
                      checked={
                        props.billOptsAndRate.billQuantityOnePerForm === null
                          ? false
                          : props.billOptsAndRate.billQuantityOnePerForm
                      }
                      onChange={e =>
                        props.handleChange(
                          'billOptsAndRate',
                          'billQuantityOnePerForm',
                          e.target.checked,
                        )
                      }
                      color="primary"
                      value={billQuantityOnePerFormValue}
                      icon={
                        <CheckBoxOutlineBlankIcon
                          classes={{ root: classes.checkBoxBlank }}
                          color="secondary"
                        />
                      }
                      checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                    />
                  }
                />
              </div>
            </FormControl>
          </div>
        )}
      </div>
      <br />
      <SimpleDialog
        open={state.isInfoStateTaxRateOpen}
        dialogTitle="State Sales Tax Rate Field"
        onConfirm={handleInfoModal}
        contentText="Please insert the applicable state or local tax rate in this field. If both a state and local tax are applicable, please combine them and enter the total amount in this field"
        styled={true}
      />
    </AccessControl>
  );
};

export default withStyles(styles)(GenBillTwo);
